'use client';
import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

const footerLinks = [
  { label: 'Accueil', href: '/' },
  { label: 'Parler à Marc', href: '/book-a-session' },
  { label: 'Plans IA', href: '/ai-plans' },
  { label: 'Dictionnaire', href: '/dictionary' },
  { label: 'Grammaire', href: '/grammar-guide' },
  { label: 'Espace Étudiant', href: '/sign-up-login' },
];

export default function Footer() {
  return (
    <footer style={{ background: '#0A1219', borderTop: '1px solid rgba(201,168,76,0.12)' }}>
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 lg:px-16 xl:px-20 py-14 lg:py-18">
        <div className="grid grid-cols-1 md:grid-cols-[1.8fr_1fr_1fr] gap-10 lg:gap-16">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <AppLogo size={32} />
              <div className="flex flex-col leading-none">
                <span className="font-extrabold text-base text-white tracking-tight">Anglaispourvous</span>
                <span className="text-[0.55rem] tracking-[0.18em] uppercase font-semibold mt-0.5" style={{ color: 'rgba(201,168,76,0.65)' }}>
                  Immersion · Coaching · Conversation
                </span>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-xs" style={{ color: 'rgba(255,255,255,0.45)' }}>
              La méthode immersion totale de Marc Herbaut — 45 ans au Canada, maintenant à votre service en France.
            </p>
            <div className="flex items-center gap-2.5 mt-6">
              <a
                href="https://linkedin.com/in/marc-herbaut-3b007b8a"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg flex items-center justify-center transition-all duration-200"
                style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' }}
                aria-label="LinkedIn de Marc Herbaut"
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(201,168,76,0.4)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.08)'; }}
              >
                <svg className="w-4 h-4 text-white/60" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-lg flex items-center justify-center transition-all duration-200"
                style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' }}
                aria-label="Facebook Anglaispourvous"
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(201,168,76,0.4)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.08)'; }}
              >
                <svg className="w-4 h-4 text-white/60" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-[0.6rem] font-bold uppercase tracking-[0.2em] mb-5" style={{ color: '#C9A84C' }}>Navigation</h4>
            <ul className="space-y-3">
              {footerLinks?.map((link) => (
                <li key={`footer-${link?.href}`}>
                  <Link
                    href={link?.href}
                    className="text-sm transition-colors duration-200"
                    style={{ color: 'rgba(255,255,255,0.45)' }}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.45)'; }}
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[0.6rem] font-bold uppercase tracking-[0.2em] mb-5" style={{ color: '#C9A84C' }}>Contact</h4>
            <ul className="space-y-3 text-sm" style={{ color: 'rgba(255,255,255,0.45)' }}>
              <li>
                <a href="mailto:marc@anglaispourvous.fr" className="transition-colors duration-200 hover:text-white">
                  marc@anglaispourvous.fr
                </a>
              </li>
              <li>St.-Omer, Hauts-de-France</li>
              <li>France 🇫🇷</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.25)' }}>
            © 2025 Anglaispourvous — Marc Herbaut. Tous droits réservés.
          </p>
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.25)' }}>
            English Tuteur · Coaching · Immersion · Conversation 🍁
          </p>
        </div>
      </div>
    </footer>
  );
}